<template>
  <div>
    <div class="content">
      <div class="header-table">
        <table>
          <tbody>
          <tr>
            <td class="header-in-table">{{ form.inspectionTitle }}</td>
            <td rowspan="2" class="th-background" style="width: 40px">결<br /><br />재</td>
            <td class="th-background" style="width: 120px">작성자</td>
            <td class="th-background" style="width: 120px">검토자</td>
            <td class="th-background" style="width: 120px">회람자</td>
            <td class="th-background" style="width: 120px">승인자</td>
          </tr>
          <tr>
            <td class="content-title" valign="bottom"><i class="dot"></i> 기본정보</td>
            <td class="signCell" :style="{ backgroundImage: typeof form.sign1 !== 'undefined' ? `url(${form.sign1.sign})` : '' }"></td>
            <td class="signCell" :style="{ backgroundImage: typeof form.sign2 !== 'undefined' ? `url(${form.sign2.sign})` : '' }"></td>
            <td class="signCell" :style="{ backgroundImage: typeof form.sign3 !== 'undefined' ? `url(${form.sign3.sign})` : '' }"></td>
            <td class="signCell" :style="{ backgroundImage: typeof form.sign4 !== 'undefined' ? `url(${form.sign4.sign})` : '' }"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <table>
          <tbody>
          <tr>
            <th>교회명</th>
            <td colspan="3">{{ form.stdInfo.field_name }}</td>
            <th>작성자 소속</th>
            <td colspan="3">{{ form.stdInfo.department }}</td>
          </tr>
          <tr>
            <th>점검일</th>
            <td colspan="3">{{ form.stdInfo.점검일 }}</td>
            <th>작성자 성명</th>
            <td colspan="3">{{ form.stdInfo.writer_name }}</td>
          </tr>
          <tr>
            <th>점검장소</th>
            <td colspan="3">{{ form.stdInfo.점검장소 }}</td>
            <th>재해형태</th>
            <td colspan="3">{{ form.stdInfo.재해형태 }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!--    장비정보-->
      <div class="content-table">
        <div class="content-title mt-28px"><i class="dot"></i>장비 정보</div>
        <table-equipment
          :list="form.equipmentList"
          :isPrint="true"
          :isReadonly="board.readonly"
        ></table-equipment>
      </div>

      <div class="content-table">
        <div class="content-title mt-28px"><i class="dot"></i>{{ form.inspectionTitle }}</div>
        <TableInspectMerge
          :is-print="true"
          :is-readonly="board.readonly"
          :table-header-note="[{ text: '비고(보완계획)', width: '240' }]"
          v-model="form.inspectList"
          :only-pc="true"
        />
      </div>

      <div class="content-table print-break-page mt-28px">
        <div class="content-title"><i class="dot"></i> 사진대지</div>
        <photo-upload-grid-module
          :printRowCount="1"
          v-model="form.photoList"
          :is-print="true"
          :readonly="board.readonly"
          placeholder="신축현장 점검"
        />
      </div>
    </div>

  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableEquipment from '@/components/TableEquipment'
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
export default {
  name: "Print720",
  components: {PhotoUploadGridModule, DateSelector, TableInspectMerge, TableEquipment },
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    getTitles() {
      if (!this.form.inspectList) {
        return [];
      }
      return this.form.inspectList.map((item) => item.title);
    },
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 14px;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 10px;
    }
  }
  .header-table {
    table {
      width: 100%;
      border-collapse: collapse;
      tr:nth-child(1) {
        text-align: center;
        td {
          padding: 10px;
        }
        td:nth-child(n + 2) {
          font-size: 18px;
          font-weight: 500;
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
      tr:nth-child(2) {
        height: 100px;
        td:nth-child(1) {
          padding-bottom: 15px;
        }
        td:nth-child(n + 2) {
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
    }
    .header-in-table {
      font-size: 32px;
      font-weight: 700;
      line-height: 24px;
    }
    .signCell {
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .content-table {
    .sub-header,
    .item-label {
      padding: 14px;
      text-align: left;
      font-size: 18px;
    }
    .sub-header {
      font-weight: 700;
    }
    .row-title {
      font-weight: 500;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th,
      td {
        border: 1px solid #cdcdcd;
        text-align: center;
        min-height: 55px;
        height: 55px;
        font-size: 18px;
      }
      th {
        background-color: #f9f9f9;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
        img {
          display: inline-block;
        }
      }
      .check-container {
        padding: 10px 14px 0 14px;
        text-align: left;

        div {
          margin-bottom: 8px;
        }
        img {
          display: inline-block;
          margin-right: 8px;
        }
      }
      .text-left {
        text-align: left;
        padding: 10px 14px;
      }
    }

    /*서명 테이블*/
    .sign-table {
      th,
      td {
        font-size: 14px;
      }

      tr th:nth-child(1),
      tr td:nth-child(1),
      tr th:nth-child(8),
      tr td:nth-child(8) {
        width: 64px;
      }

      .signCell {
        white-space: nowrap;
        min-width: 90px;
        padding: 2px;
        height: 50px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .signSpace {
        width: 10px;
        border-top: none;
        border-bottom: none;
      }
    }
  }

  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }

  .print-break-page {
    page-break-before: always;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
    break-inside: avoid;
  }
}
.photoWrap:nth-child(2n) {
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.table-inspect-merge-print {
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    color: #3c3c3c;

    display: flex;
    align-items: center;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 14px;
    }
  }

  .print-textarea,
  .print-input {
    border: none;
    border-radius: 0;
  }

  table {
    th,
    td {
      border: 1px solid #757575 !important;
      min-height: 55px !important;
      height: 55px !important;
      font-size: 18px !important;
      text-align: center !important;
    }
    th {
      background-color: #ececec !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }

    .title-tr > td {
      background-color: #ececec !important;
      text-align: left !important;
    }

    .content[colspan='4'],
    .content[colspan='7']{
      padding: 0 !important;

      & > div {
        display: grid !important;
        grid-template-columns: auto 1fr;
        gap: 0 !important;
      }
      p {
        flex: none ;
        padding: 0.7rem !important;
        width: 140px !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        margin: 0 !important;
        border-left: 1px solid #757575 !important;
        white-space: pre-wrap;

        display: grid;
        align-items: center;
      }
    }
  }
}
</style>
